import React, {Component} from 'react';
import { Checkbox } from 'react-icheck'
import {Modal,Button,ButtonToolbar,FormControl,FormGroup,ControlLabel,Row,Col} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

class TextFieldModal extends Component {
    constructor(props) {
      super(props)
      this.state = {valid_field:null,isCheckAll:false,show:false,fieldInfo:{title:'',value:'',title2:'',value2:null,componentClass:'text'},type:'',key:''}
    }
    onHide(){
     this.setState({show:false})
    }

    loadInfo(fieldInfo){
      this.setState({show:true,fieldInfo:fieldInfo})
    }

    onChange(e){
      let {fieldInfo} = this.state
      fieldInfo.value = e.target.value
      this.setState({fieldInfo:fieldInfo})
    }

    onChange2(e){
      let {fieldInfo} = this.state
      fieldInfo.value2 = e.target.value
      this.setState({fieldInfo:fieldInfo})
    }

    onConfirm(){
      let {isValid} = this.props
      let {fieldInfo} = this.state
      if (isValid) {
        this.setState({valid_field:null},()=>{
          if (!fieldInfo.value) {
            this.setState({valid_field:'error'})
            return false 
          } else 
            this.onConfirm_(fieldInfo)
        })
      } else {
        this.onConfirm_(fieldInfo)
      }
    }

    onConfirm_(fieldInfo) {
      if(this.props.onConfirm!==undefined){
        this.setState({isCheckAll:false})
        this.props.onConfirm(fieldInfo)
      }
      this.onHide()
    }

    onClear(){
      let {fieldInfo} = this.state
      fieldInfo.value = ''
      fieldInfo.value2 = ''
      this.setState({fieldInfo:fieldInfo})

      if(this.props.onClear!==undefined){
        this.props.onClear(fieldInfo)
        this.onHide()
      }
      
    }

    renderConfirmButton(){
      let {confirmTitle,cancelTitle,deleteTitle} = this.props
      let {fieldInfo} = this.state
      let showClear = (fieldInfo.showClear!==undefined )?fieldInfo.showClear:false
      return (
          <ButtonToolbar className='pull-right'>
            <Button onClick={this.onClear.bind(this)} bsStyle='default' style={{minWidth:'120px',display:(showClear?'block':'none')}}><FontAwesome name='eraser'/>&nbsp;{deleteTitle}</Button>
            <Button onClick={this.onConfirm.bind(this)} bsStyle='primary' style={{minWidth:'80px'}}><FontAwesome name='thumbs-o-up'/>&nbsp;{confirmTitle}</Button>
            <Button onClick={this.onHide.bind(this)} bsStyle='default' style={{minWidth:'80px'}}><FontAwesome name='close'/>&nbsp;{cancelTitle}</Button>

          </ButtonToolbar>)
      
    }

    renderFormControl2(fieldInfo){
      if(fieldInfo.value2!==null && fieldInfo.value2!==undefined){
        return [
          <ControlLabel>{fieldInfo.title2}</ControlLabel>,
          <FormControl
                      {...this.props}
                      autoFocus
                      componentClass={fieldInfo.componentClass}                       
                      value={fieldInfo.value2}  
                      onChange={this.onChange2.bind(this)}                                                    
                    />
        ]
      }else{
        return ('')
      }
    }

    onCheckAll(value) {
      let {isCheckAll} = this.state
      if (value)
        isCheckAll = false
      else 
        isCheckAll = true

      this.setState({isCheckAll:isCheckAll})
      this.props.onCheckAll(isCheckAll)
    }

    renderCheckAll() {
      let {isCheckAll} = this.state
      return(
        <div style={{marginTop:'5px'}}>
          <Checkbox
            onChange={this.onCheckAll.bind(this,isCheckAll)}
            checked={isCheckAll}
            checkboxClass="icheckbox_minimal"
            increaseArea="20%"
            label={' ใส่ข้อความนี้ในทุกหน้า'}
          >
          </Checkbox>
        </div>
      )
    }

    render(){
      let {title,isAllText,isValid} = this.props
      let {show,fieldInfo,valid_field} = this.state
      return (
        <Modal show={show} onHide={this.onHide.bind(this)} dialogClassName="alert-popup-dialog">
          <Modal.Header>
            {title}
          </Modal.Header>
          <Modal.Body>
            <div className='text-field-modal'>
              <Row>
                <Col md={12}>          
                  <FormGroup
                    validationState={isValid?valid_field:null}
                  >
                    <ControlLabel>{fieldInfo.title}</ControlLabel>
                    <FormControl
                      {...this.props}
                      autoFocus
                      componentClass={fieldInfo.componentClass}                       
                      value={fieldInfo.value}  
                      onChange={this.onChange.bind(this)}                                                    
                    />
                      {this.renderFormControl2(fieldInfo)}
                      {isAllText?this.renderCheckAll():''}
                    <FormControl.Feedback />              
                  </FormGroup>          
                </Col>
              </Row>
            </div>  
          </Modal.Body>
          <Modal.Footer>
            {this.renderConfirmButton()}
          </Modal.Footer>
        </Modal>
      )
    }
}

TextFieldModal.defaultProps = {
  title:'ทำรายการ',  
  confirmTitle:'ตกลง',
  cancelTitle:'ยกเลิก' ,
  deleteTitle:'ลบข้อความ',
  isAllText:false,
  isValid:false
}

export default TextFieldModal



// WEBPACK FOOTER //
// ./src/component/element/TextFieldModal.js